"use client"

import { useEffect } from "react"
import { usePathname } from "next/navigation"

export function AnalyticsTracker() {
    const pathname = usePathname()

    useEffect(() => {
        // Track page view
        const trackPageView = async () => {
            try {
                await fetch("/api/analytics/track", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        type: "visitor",
                        path: pathname,
                        ua: navigator.userAgent
                    })
                })
            } catch (e) { }
        }

        trackPageView()

        // Track clicks
        const handleGlobalClick = async (e: MouseEvent) => {
            const target = e.target as HTMLElement
            const elementId = target.id || target.getAttribute("data-track-id") || target.innerText?.slice(0, 20)

            if (elementId) {
                try {
                    await fetch("/api/analytics/track", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                            type: "click",
                            path: pathname,
                            element_id: elementId
                        })
                    })
                } catch (e) { }
            }
        }

        window.addEventListener("click", handleGlobalClick)
        return () => window.removeEventListener("click", handleGlobalClick)
    }, [pathname])

    return null
}
